module.exports = __webpack_public_path__ + "img/appStore-app-odrex.736a2766.svg";